<template>
  <div class="cadfm-container-horizontal">
            <Left  v-show="isVisibleLeft" :lang="lang.Left"></Left>
            <Middle :routingData="routingData" :lang="lang.Middle"></Middle>
            <!--<Right></Right>-->
 </div>
</template>

<script>
import Left from '@/components/LibraryManager/Views/LibraryNew/Left/Left'
import Middle from '@/components/LibraryManager/Views/LibraryNew/Middle/Middle'
//import Right from '@/components/LibraryManager/Views/LibraryNew/Right/Right'
import { mapGetters } from 'vuex'


export default {
  name: 'LibraryNew',
  components:{
    Left,
    Middle,
    //Right
  },
  data () {
    return {
      isVisibleRight: true,
      isVisibleLeft: true
    }
  },
  props:{
    routingData: Object,
    lang: Object
  },
  computed: {
    ...mapGetters([
      'isPlugin',
      
    ]),

  },
  
}
</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/LibraryManager/Views/LibraryNew.vue